//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapActions } from "vuex";
import logger from "@/utils/logger";

export default {
  data() {
    return {
      columns: [
        {
          name: "productNumber",
          align: "left",
          label: "Produkt",
          field: "productNumber",
          sortable: true,
        },
        {
          name: "ProductName",
          align: "left",
          label: this.$t("stock.productName"),
          field: "productName",
          sortable: true,
          headerStyle: "min-width: 120px",
          style:
            "min-width: 120px; max-width:120px; overflow:hidden; white-space:nowrap;",
        },
        {
          name: "ItemsBought",
          align: "right",
          label: this.$t("products.boughtQty"),
          field: "itemsBought",
          sortable: true,
        },
        {
          name: "ItemsSold",
          align: "right",
          label: this.$t("products.soldQty"),
          field: "itemsSold",
          sortable: true,
        },
        {
          name: "ItemsAvailable",
          align: "right",
          label: "På lager",
          field: "itemsAvailable",
          sortable: true,
        },
        {
          name: "ItemsIncoming",
          align: "right",
          label: "På vei",
          field: "itemsIncoming",
          sortable: true,
        },
        {
          name: "MaximumPoint",
          align: "right",
          label: "Maks på lager",
          field: "maximumPoint",
          sortable: true,
        },
        {
          name: "LeadTime",
          align: "right",
          label: "Ledetid",
          field: "leadTime",
          sortable: true,
        },
        {
          name: "numberOfItems",
          label: "Antall som skal overføres",
          align: "right",
          field: "numberOfItems",
          sortable: true,
          width: "100px",
        },

        // {
        //   name: "ItemsInStock",
        //   align: "right",
        //   label: this.$t("products.qty"),
        //   field: "itemsInStock",
        //   sortable: true,
        // },
        // {
        //   name: "QuantityAvailable",
        //   align: "right",
        //   label: this.$t("products.availableQty"),
        //   field: "itemsAvailable",
        //   sortable: true,
        // },
        // {
        //   name: "QuantityIncoming",
        //   align: "right",
        //   label: this.$t("products.incomingQty"),
        //   field: "itemsIncoming",
        //   sortable: true,
        // },
      ],

      itemColumns: [
        {
          name: "productNumber",
          align: "left",
          label: "Produkt",
          field: "productNumber",
          sortable: true,
        },
        {
          name: "productName",
          align: "left",
          label: "Beskrivelse",
          field: "productName",
          sortable: true,
        },
        {
          name: "numberOfItems",
          align: "right",
          label: "Antall",
          field: "numberOfItems",
          sortable: true,
        },
        {
          name: "discount",
          align: "right",
          label: "Rabatt (%)",
          field: "discount",
          sortable: true,
        },

        // {
        //   name: "warehouseName",
        //   align: "left",
        //   label: "Lager",
        //   field: "warehouseName",
        //   sortable: true,
        // },
      ],

      selectedTab: "searchTab",
      filter: "",
      suppliers: [],
      allSuppliers: [],
      stocks: [],
      selectedStocks: [],
      orderItems: [],
      selectedItems: [],
      selectedRow: [],
      supplierId: 0,
      prevSupplierId: 0,
      hideTableBottom: true,
      discounts: [],
      productCategoryLinks: [],
      fromDate: null,
      toDate: null,
      dense: true,
      confirm: false,
    };
  },
  async mounted() {
    await Promise.allSettled([
      (this.allSuppliers = await this.getSuppliers()),
      (this.suppliers = this.allSuppliers),
      (this.discounts = await this.getSupplierDiscounts()),
      (this.productCategoryLinks = await this.getProductCategoryLinks()),
      this.refresh(),
    ]);

    window.dispatchEvent(new Event("resize"));
  },

  methods: {
    ...mapActions("main", [
      "getSupplierStocksByPeriod",
      "getSuppliers",
      "getSuggestedOrderItemsBySupplier",
      "getSupplierDiscounts",
      "getProductCategoryLinks",
      "postPurchaseOrderFromOrderItems",
    ]),

    enterCheck(event) {
      if (event.key === 'Enter' && this.suppliers.length == 1) {
          this.supplierId = this.suppliers[0].id;
      }
    },

    focusInput(selectedItems) {
 
      if (selectedItems.length > 0) {
   
        this.selectedRow = selectedItems[selectedItems.length - 1].productId;
        this.$nextTick(() => {
          const quantityInput = this.$refs.quantityInput;
          if (quantityInput) {
            quantityInput.$el.querySelector("input").focus();
          }
        });
      }
    },

    async refresh() {
      this.stocks = [];
      this.selectedStocks = [];
      this.orderItems = [];
      this.filter = "";

      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });

      //this.getSupplierStocks(); // trengs vel ikke?

      setTimeout(() => {
        notif();
      }, 500);
    },

    moveToOrder() {
      for (var i = 0; i < this.selectedStocks.length; i++) {
        var item = this.selectedStocks[i];
        if (
          this.orderItems.filter((x) => x.productId == item.productId).length ==
          0
        ) {
          var selectedItem = {};
          selectedItem.productId = item.productId;
          selectedItem.productNumber = item.productNumber;
          selectedItem.productName = item.productName;
          selectedItem.supplierId = item.supplierId;
          selectedItem.numberOfItems = item.numberOfItems || 1;
          //selectedItem.id = item.id;

          this.orderItems.push(selectedItem);
        }
      }
      this.selectedStocks = [];
      this.updateDiscount();
    },

    async updateDiscount() {
      if (this.supplierId <= 0) return; // eller == '' ??

      var updatedOrderItems = [];

      this.orderItems.forEach((item) => {
        var categoryLinksIds = this.productCategoryLinks
          .filter((x) => x.productID === item.productId)
          .map((x) => x.productCategoryID);
        if (categoryLinksIds) {
          var productDiscount = this.discounts.find(
            (x) =>
              x.supplierId === this.supplierId &&
              categoryLinksIds.includes(x.productCategoryId)
          );
          if (productDiscount && productDiscount.discount > 0)
            item.discount = productDiscount.discount;
        }
        updatedOrderItems.push(item);
      });
      this.orderItems = updatedOrderItems;
    },

    deleteLine(index) {
      this.orderItems.splice(index, 1);
    },

    clearOrder() {
      this.orderItems = [];
    },

    async saveOrder() {
      var items = [];

      this.orderItems.forEach(function(item) {
        var newItem = {};
        newItem.productId = item.productId;
        newItem.itemText = item.productName;
        newItem.numberOfItems = item.numberOfItems;
        newItem.DiscountPercentage = item.discount || null;
        items.push(newItem);
      });

      try {
        await this.postPurchaseOrderFromOrderItems(items);

        this.clearOrder();
        this.filter = "";
        this.selectedTab = "searchTab";

        this.$q.notify({
          type: "positive",
          message: this.$t("common.saveOk"),
        });
      } catch (error) {
        logger.log("error", error);
        this.$q.notify({
          type: "negative",
          message: `${this.$t(
            "common.errorSave"
          )}. ${this.$utils.GetErrorMessage(error)}`,
        });
      }
    },

    async addSuggestedItems() {
      if (this.supplierId != "") {
        var suggestedItems = await this.getSuggestedOrderItemsBySupplier(
          this.supplierId
        );
        if (suggestedItems.length > 0) {
          var anyNewItems = false;
          for (var i = 0; i < suggestedItems.length; i++) {
            var element = suggestedItems[i];
            var orderItem =
              this.orderItems.length > 0
                ? this.orderItems.find((x) => x.productId === element.productId)
                : null;
            if (!orderItem) {
              var newItem = {};
              newItem.productId = element.productId;
              newItem.productNumber = element.productNumber;
              newItem.productName = element.productName;
              newItem.supplierId = this.supplierId;
              newItem.numberOfItems = element.numberOfItems;
              this.orderItems.push(newItem);
              anyNewItems = true;
            }
          }
          if (anyNewItems) {
            this.updateDiscount();
          }
        }
      }
    },

    async supplierSelected() {
      if (this.supplierId != this.prevSupplierId) {
        if (this.orderItems.length > 0) {
          this.confirm = true;
          // spør "Vil du tømme ordre og bytte til annen leverandør?"
          //this.clearOrder();
        } else {
          this.changeSupplier();
        }
      }
    },

    restoreSupplier() {
      this.supplierId = this.prevSupplierId;
    },

    changeSupplier() {
      this.clearOrder();
      this.prevSupplierId = this.supplierId;
      this.getSupplierStocks();
    },

    async getSupplierStocks() {
   
      if (this.supplierId != "" && this.fromDate && this.toDate) {
        //clearOrder(); // tømme ordren?
        this.stocks = await this.getSupplierStocksByPeriod({
          supplierId: this.supplierId,
          fromDate: this.toEngFormat(this.fromDate),
          toDate: this.toEngFormat(this.toDate),
        });
      } else {
        this.stocks = [];
      }

    },

    filterSuppliers(val, update) {
      if (!this.suppliers) {
        update();
        return;
      }
      update(() => {
        this.suppliers = this.allSuppliers.filter(
          (s) => s.name.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });
    },

    async hideFromDate(pdate) {
      pdate.hide();
      this.fromDateChanged();
    },

    async hideToDate(pdate) {
      pdate.hide();
      this.toDateChanged();
    },

    async fromDateChanged() {
      this.fromDate = this.autoCompleteDate(this.fromDate);
      this.getSupplierStocks();
    },

    async toDateChanged() {
      this.toDate = this.autoCompleteDate(this.toDate);
      this.getSupplierStocks();
    },

    toEngFormat(strDate) {
      var splitDate = strDate.split("-");
      return splitDate[2] + "-" + splitDate[1] + "-" + splitDate[0];
    },

    autoCompleteDate(strDate) {
      if (strDate.length > 0 && strDate.length < 7) {
        if (isNaN(parseInt(strDate))) return "";
        try {
          if (strDate.length < 6) {
            let today = new Date();
            if (strDate.length == 1)
              strDate = "0" + strDate + date.formatDate(today, "MMYY");
            else if (strDate.length == 2)
              strDate = strDate + date.formatDate(today, "MMYY");
            else if (strDate.length == 3) {
              strDate = strDate.substring(0, 2) + "0" + strDate.substring(2, 3);
              strDate = strDate + date.formatDate(today, "YY");
            } else if (strDate.length == 4)
              strDate = strDate + date.formatDate(today, "YY");
            else if (strDate.length == 5) {
              strDate = strDate.substring(0, 4);
              strDate = strDate + date.formatDate(today, "YY");
            }
          }

          let newDate = date.extractDate(strDate, "DDMMYY");
          return date.formatDate(newDate, "DD-MM-YYYY");
        } catch (error) {
          return "";
        }
      }
      return strDate;
    },
  },
};
